export const ID_KEYS = {
  back: "back",
  backLoading: "backLoading",
  backUrl: "backUrl",
  front: "front",
  frontLoading: "frontLoading",
  frontUrl: "frontUrl",
};
